module.exports = __webpack_public_path__ + "d11f7bc1b632d636abf7d700cb606c41.svg";